module.exports = __webpack_public_path__ + "img/KünstlerPrinzessin.93a25abf.jpg";